//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <p style="font-size:16px; padding-bottom:20px;">Новости</p>

    <div v-if="commonData.isLoaded == true" v-for="(item, key) in commonData.news" :key="key" style="width:900px; margin-bottom:40px;">
     <div v-if="item.publish == true">
      <div style="width:100%; font-family:'Roboto Thin'; font-size:22px; padding-bottom:5px; float:left;">
        <!--Icon type="ionic" style="font-size:15px; position:fixed; padding-top:3px;"></Icon-->
        <span style="padding-left:0px;">{{item.name}}</span>
      </div>
      <div style="width:100%; font-size:13px; padding-bottom:20px; float:left;">
        {{item.createdAt | formatDate}} &nbsp;&nbsp;&nbsp;{{commonData.users[item.author].Name}}
      </div>
      <div v-html="item.body" style="width:100%; font-size:15px; padding-bottom:15px; float:left;">
      </div>
      <div style="width:100px; border-bottom:1px dotted #ccc; clear:left;">
        &nbsp;
      </div>
     </div>
    </div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'commonData'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// News.vue?9560b556